import { render, staticRenderFns } from "./MyCouponsPointsDesc.vue?vue&type=template&id=04c02373&scoped=true&"
import script from "./MyCouponsPointsDesc.vue?vue&type=script&lang=js&"
export * from "./MyCouponsPointsDesc.vue?vue&type=script&lang=js&"
import style0 from "./MyCouponsPointsDesc.vue?vue&type=style&index=0&id=04c02373&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c02373",
  null
  
)

export default component.exports